module.exports = __webpack_public_path__ + "static/buoy-logo-0f7e33a29d562e0a783fa9a3408a6c34.svg";